import BordOneToneIcon from '../../../../components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import './WarehouseTemporaryStorageMarker.scss';

const WarehouseTemporaryStorageMarker = ({ orderTemporaryStorageReasons }: IWarehouseTemporaryStorageMarkerProps) => {
  const hasTemporaryStorage = orderTemporaryStorageReasons.length > 0;
  const reasonsToShowLimit = 1;
  const extraReasons =
    orderTemporaryStorageReasons.length > reasonsToShowLimit
      ? orderTemporaryStorageReasons.length - reasonsToShowLimit
      : 0;
  const hasExtraReasons = extraReasons > 0;
  const reasonsText = `${orderTemporaryStorageReasons.slice(0, reasonsToShowLimit).join(', ')}`;

  if (!hasTemporaryStorage) return null;
  return (
    <div className="warehouseTemporaryStorageMarker">
      <BordOneToneIcon variant="warehouse" customWidth="10px" />
      <span className="markerTitle">Parada en bodega: </span>
      {reasonsText}
      {hasExtraReasons && <span className="extraReasons"> +{extraReasons}</span>}
      {hasExtraReasons && (
        <div className="warehouseTemporaryStorageMarkerHoverElement">
          {orderTemporaryStorageReasons.map(reason => (
            <div key={reason} className="extraReason">
              {reason}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default WarehouseTemporaryStorageMarker;

interface IWarehouseTemporaryStorageMarkerProps {
  orderTemporaryStorageReasons: string[];
}
